import { useCallback, useState } from 'react';

export function deepMerge(target, source) {
  if (typeof source !== 'object' || source === null) {
    return source;
  }

  const result = { ...target };

  Object.keys(source).forEach((key) => {
    if (source[key] !== undefined) {
      if (typeof source[key] === 'object' && typeof result[key] === 'object') {
        result[key] = deepMerge(result[key], source[key]);
      } else {
        result[key] = source[key];
      }
    }
  });

  return result;
}

/**
 * Immutably set a (possibly dot-nested) field on a copy of `target`, cloning each
 * object along the path so the original is untouched.
 */
export function setByPath(target, field, value) {
  const newData = { ...target };
  const parts = field.split('.');
  let obj = newData;

  while (parts.length > 1) {
    const key = parts.shift();
    obj[key] = { ...obj[key] };
    obj = obj[key];
  }

  obj[parts[0]] = value;

  return newData;
}

export default function useForm(initial) {
  const [data, setData] = useState(initial);

  const update = useCallback((fieldOrFields, value) => {
    if (typeof fieldOrFields === 'object') {
      return setData((current) => deepMerge(current, fieldOrFields));
    }

    const field = fieldOrFields;

    setData((current) => setByPath(current, field, value));
  }, []);

  const reset = () => setData({ ...initial });

  return {
    data,
    setData,
    update,
    reset,
  };
}
